"use client";

import styles from "./TermsContent.module.css";
import { FormattedMessage } from "react-intl";
import { AppConstants } from "@/app/constants";

export default function TermsContent() {
  const poolName = AppConstants.PoolName;
  const poolSite = AppConstants.PoolSite;

  return (
    <div className={styles.content}>
      <p className={styles.title}>
        <FormattedMessage
          id="terms-title"
          values={{
            serviceSite: poolSite,
            serviceName: poolName,
            serviceName1: poolName,
            serviceName2: poolName,
          }}
        />
      </p>

      <p className={styles.title}>
        <FormattedMessage id="terms-1" />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-1-1" values={{ serviceName: poolName }} />
      </p>

      <p className={styles.title}>
        <FormattedMessage id="terms-2" />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-2-1" />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-2-2" values={{ serviceName: poolName }} />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-2-3" />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-2-4" />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-2-5" />
      </p>

      <p className={styles.title}>
        <FormattedMessage id="terms-3" values={{ serviceName: poolName }} />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-3-1" values={{ serviceName: poolName }} />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-3-2" values={{ serviceName: poolName }} />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-3-3" values={{ serviceName: poolName }} />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-3-4" values={{ serviceName: poolName }} />
      </p>

      <p className={styles.title}>
        <FormattedMessage id="terms-4" />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-4-1" />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-4-2" values={{ serviceName: poolName }} />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-4-3" />
      </p>

      <p className={styles.title}>
        <FormattedMessage id="terms-5" />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-5-1" />
      </p>

      <p className={styles.text}>
        <FormattedMessage
          id="terms-5-2"
          values={{
            serviceName: poolName,
            serviceName1: poolName,
            serviceName2: poolName,
          }}
        />
      </p>

      <p className={styles.title}>
        <FormattedMessage id="terms-6" />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-6-1" />
      </p>

      <p className={styles.text}>
        <FormattedMessage id="terms-6-2" values={{ serviceName: poolName }} />
      </p>

      <p className={styles.title}>
        <FormattedMessage id="terms-7" />
      </p>

      <p className={styles.text}>
        <FormattedMessage
          id="terms-7-1"
          values={{
            serviceName: poolName,
            serviceName1: poolName,
          }}
        />
      </p>

      <p className={styles.title}>
        <FormattedMessage id="terms-8" values={{ serviceName: poolName }} />
      </p>

      <p className={styles.title}>
        <FormattedMessage
          id="terms-9"
          values={{
            serviceName: poolName,
            serviceName1: poolName,
          }}
        />
      </p>
    </div>
  );
}
